import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function MobileDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Mobile Auto Detailing',
    serviceType: 'Mobile Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Ventura County', 'Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks', 'Simi Valley', 'Moorpark', 'Newbury Park', 'Westlake Village'],
    description: 'Fully mobile car detailing throughout Ventura County. We bring the detail shop to your home or office with our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  };
  const faqs = [{
    question: 'What is mobile car detailing?',
    answer: "Mobile car detailing is a professional cleaning and restoration service that comes to you. Mike's Pro Detail brings our own water and detailing equipment to your home or office anywhere in Ventura County — no drop-off or waiting room required. We require access to a standard electrical outlet at the service location."
  }, {
    question: 'Do you bring your own water and electricity?',
    answer: 'We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  }, {
    question: 'What areas do you cover for mobile detailing?',
    answer: 'We serve all of Ventura County including Camarillo, Oxnard, Ventura, Thousand Oaks, Simi Valley, Moorpark, Newbury Park, and Westlake Village, plus select surrounding areas.'
  }, {
    question: 'How much does mobile detailing cost?',
    answer: 'Exterior details start at $160, interior at $180, and our popular full detail at $300, with adjustments for vehicle size. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'How long does mobile detailing take?',
    answer: 'A wash and wax takes about 1.5\u20132 hours, interior detailing 2\u20133 hours, and a full detail 3\u20134 hours. We never rush — quality results take proper time.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Mobile Detailing',
    item: 'https://www.fulldetailpro.com/services/mobile-detailing'
  }];
  return <ServicePageLayout title="Mobile Detailing Ventura County" subtitle="The detail shop that comes to you. Professional mobile car detailing at your home or office anywhere in Ventura County — no drop-off, no waiting." metaDescription="Mobile detailing in Ventura County. Mike's Pro Detail brings interior, exterior & full car detailing to your home or office. 5-star service. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-1161" data-mp="un4283x1da4m">
      <p data-id="element-1162" data-mp="2g0ypx9kd198p">
        At Mike's Pro Detail,{' '}
        <strong data-id="element-1163" data-mp="1sxvuzmtttep">mobile detailing in Ventura County</strong> means professional,
        showroom-quality car care delivered directly to your driveway. There's
        no need to drop your vehicle off, sit in a waiting room, or rearrange
        your day around a detail shop's hours. We bring a fully equipped
        detailing operation — complete with our own water, detailing equipment,
        and premium products — straight to your home or office, wherever you are
        in Ventura County. We require access to a standard electrical outlet at
        the service location.
      </p>

      <h2 data-id="element-1164" data-mp="3nzw4zwm3ywwl">Why Choose Mobile Car Detailing?</h2>
      <p data-id="element-1165" data-mp="3ny2vm9k41ykw">
        Mobile car detailing in Ventura County combines the highest quality
        results with unmatched convenience. Instead of automated car washes that
        scratch and swirl your paint, our technicians hand-detail every vehicle
        with meticulous care. And because we come to you, you reclaim hours of
        your day while we transform your car on-site.
      </p>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1166" data-mp="16s47l0nkechl">
        <li className="flex items-start" data-id="element-1167" data-mp="11s84r4qlsr3m">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1168" data-mp="11tji9w9upd7x" />
          <span data-id="element-1169" data-mp="1fsiv86o043o9">
            <strong data-id="element-1170" data-mp="1ft2d5ndnis2a">Total Convenience:</strong> We detail your car at your home,
            office, or apartment — you never have to leave.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1171" data-mp="1ppxaw423oofi">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1172" data-mp="1povxhsxm3pum" />
          <span data-id="element-1173" data-mp="1krm1tvjmqhyc">
            <strong data-id="element-1174" data-mp="1kq2ly61vy8x3">We Bring the Equipment:</strong> We bring our own water and
            detailing equipment. We require access to a standard electrical
            outlet at the service location.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1175" data-mp="1uhp2mhwzt078">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1176" data-mp="28geyxvbzmvuj" />
          <span data-id="element-1177" data-mp="28elos6261ths">
            <strong data-id="element-1178" data-mp="23hlipv5bgqqo">Premium, Hand-Crafted Results:</strong> Safe wash methods
            and professional-grade products on every vehicle.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1179" data-mp="2n46ltv4cstc3">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1180" data-mp="2s3037ymrh4hj" />
          <span data-id="element-1181" data-mp="2s045obetshtm">
            <strong data-id="element-1182" data-mp="2e2z2cj6hxx22">Flexible Scheduling:</strong> Including weekends, to fit
            your busy Ventura County lifestyle.
          </span>
        </li>
      </ul>

      <h2 data-id="element-1183" data-mp="2i2hcql0oypqn">Our Mobile Detailing Services</h2>
      <p data-id="element-1184" data-mp="24cdus68uhi70">
        Every service we offer is performed on-site as part of our mobile
        detailing operation. Explore each in detail:
      </p>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-1185" data-mp="29572n2zm16nb">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1186" data-mp="1ufrapjocev61">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1187" data-mp="1qd4opzecs4gr">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/full-detail" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1188" data-mp="3na0qgzwgho9z">
          Full Car Detail &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1189" data-mp="evs0lzlbjbli">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/headlight-restoration" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1190" data-mp="5tivxqcqecg1">
          Headlight Restoration &rarr;
        </Link>
        <Link to="/services/hybrid-ceramic-spray" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1191" data-mp="2llyjsjaedeis">
          Hybrid Ceramic Spray &rarr;
        </Link>
      </div>

      <h2 data-id="element-1192" data-mp="1a4vkw4ul2os6">Serving All of Ventura County</h2>
      <p data-id="element-1193" data-mp="1a42dr2rppx9i">
        Our mobile detailing service reaches every community in Ventura County.
        Find your city for local details and pricing:{' '}
        <Link to="/ventura-county/camarillo" data-id="element-1194" data-mp="1junjrb9pu42g">Camarillo</Link>,{' '}
        <Link to="/ventura-county/oxnard" data-id="element-1195" data-mp="1juf8fnt8r6td">Oxnard</Link>,{' '}
        <Link to="/ventura-county/ventura" data-id="element-1196" data-mp="1osytlm00geko">Ventura</Link>,{' '}
        <Link to="/ventura-county/thousand-oaks" data-id="element-1197" data-mp="1ovkytezfihzq">Thousand Oaks</Link>,{' '}
        <Link to="/ventura-county/simi-valley" data-id="element-1198" data-mp="1ttmio24oilc9">Simi Valley</Link>,{' '}
        <Link to="/ventura-county/moorpark" data-id="element-1199" data-mp="1xtex2vgr7lpj">Moorpark</Link>,{' '}
        <Link to="/ventura-county/newbury-park" data-id="element-1200" data-mp="3vkhhl2u6n0n7">Newbury Park</Link>, and{' '}
        <Link to="/ventura-county/westlake-village" data-id="element-1201" data-mp="3vmkiihwvie6p">Westlake Village</Link>.
      </p>
    </ServicePageLayout>;
}